// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../node_modules/rescript/lib/es6/array.js";
import * as $$String from "../../../node_modules/rescript/lib/es6/string.js";

function labelString(values) {
  return $$String.concat("#", $$Array.to_list($$Array.mapi((function (index, str) {
                        return String(index + 1 | 0) + "_" + str;
                      }), values)));
}

export {
  labelString ,
  
}
/* No side effect */
